import gql from 'graphql-tag';

export default gql`
  mutation CookbookReplaceIngredientMutation(
    $dishId: Int!
    $originalIngredientId: String!
    $replacementIngredientId: String!
  ) {
    cookbook {
      replaceIngredient(
        dishId: $dishId
        originalIngredientId: $originalIngredientId
        replacementIngredientId: $replacementIngredientId
      ) {
        __typename
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          name
          description
        }
        ... on BasicMutationSuccess {
          code
        }
      }
    }
  }
`;
